const isIn =
    <T = any>(as: Set<T>) =>
    (a: T) =>
        as.has(a);

const all = <T = any>(pred: (a: T) => boolean, as: Set<T>) => {
    for (const a of as) if (!pred(a)) return false;
    return true;
};

export const eqSet = <T = any>(as: Set<T>, bs: Set<T>): boolean =>
    as.size === bs.size && all(isIn(bs), as);
